import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { RuleTabs, TenantSelect } from '../../components';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../../atomic/molecules';

import { useRuleService } from '../../context/RuleServiceContext';
import { RSW } from './ruleServiceWrapper.classes';

export const RuleServiceWrapper: FC<any> = () => {
    const { tenant, isLoading, clearRuleData } = useRuleService();

    const { t } = useTranslation();
    return (
        <>
            <div className={RSW.breadcrumbSection}>
                <SCUIBreadCrumb
                    dontShowHome={true}
                    onlyTitle={tenant === '' ? t('ruleManagement.breadcrumbDomainSelect') : t('ruleManagement.titlev2')}
                    style={{ cursor: 'pointer' }}
                    components={[
                        {
                            title: t('ruleManagement.breadcrumbDomainSelect'),
                            link: '/rule-managementV2',
                            onClick: clearRuleData,
                        },
                        {
                            title: t('ruleManagement.titlev2'),
                            link: '/rule-managementV2',
                        },
                    ]}
                />
            </div>
            {isLoading && (
                <Grid
                    className={RSW.loadingRow}
                    size={{
                        xl: 12,
                        md: 12,
                        lg: 12,
                        xs: 12
                    }}>
                    <div className={RSW.loadingSection}>
                        <SCUILoadingLinear display={isLoading} />
                    </div>
                </Grid>
            )}
            {tenant === '' ? (
                <div className={RSW.tenantSelectSection}>
                    <TenantSelect />
                </div>
            ) : (
                <div className={RSW.tabsSection}>
                    <RuleTabs />
                </div>
            )}
        </>
    );
};
